import React from "react";
import { Link } from "react-router-dom";
import HandymanRoundedIcon from "@mui/icons-material/HandymanRounded";
import WarehouseRoundedIcon from "@mui/icons-material/WarehouseRounded";
import DeckRoundedIcon from "@mui/icons-material/DeckRounded";
import ChevronRightRoundedIcon from "@mui/icons-material/ChevronRightRounded";
import { IconTile, PageHeader, PageShell } from "../../components/UI/Page";

// /tools — one place to reach every designer. Unlisted while the designers
// are being tested: no nav item, FAQ entry, news or widget (per Blake).
// A new designer gets a card here and its own /tools/<name> route.

const DESIGNERS = [
  {
    path: "/tools/building-designer",
    name: "Building Designer",
    description:
      "Post-frame buildings in 3D — size, roof, colors, doors, windows and porches — with a plan view. Save, share a link, or print it for the customer.",
    icon: WarehouseRoundedIcon,
    tone: "amber",
  },
  {
    path: "/tools/deck-designer",
    name: "Deck Designer",
    description:
      "Decks in 3D with a material list. Framing is checked against the IRC deck tables, with railing, stairs and footings counted. Copy, download or print the list.",
    icon: DeckRoundedIcon,
    tone: "emerald",
  },
];

const ToolsHub = () => (
  <PageShell size="lg">
    <PageHeader
      icon={HandymanRoundedIcon}
      tone="sky"
      title="Tools"
      description="Design tools for working up a project with a customer. Designs save to your account and open for anyone signed in from a shared link."
    />
    <div className="grid grid-cols-1 gap-3 sm:grid-cols-2">
      {DESIGNERS.map((tool) => (
        <Link
          key={tool.path}
          to={tool.path}
          className="app-card group flex h-full items-start gap-4 rounded-2xl border p-5 transition duration-200 hover:-translate-y-0.5 hover:border-sky-400/50 focus:outline-none focus-visible:ring-2 focus-visible:ring-sky-500"
        >
          <IconTile icon={tool.icon} tone={tool.tone} />
          <div className="min-w-0 flex-1">
            <p className="font-semibold leading-snug tracking-tight">{tool.name}</p>
            <p className="app-muted mt-1 text-sm leading-relaxed">{tool.description}</p>
          </div>
          <ChevronRightRoundedIcon
            className="app-muted mt-0.5 shrink-0 opacity-40 transition group-hover:translate-x-0.5 group-hover:text-[color:var(--app-accent)] group-hover:opacity-100"
            sx={{ fontSize: 20 }}
          />
        </Link>
      ))}
    </div>
  </PageShell>
);

export default ToolsHub;
